import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {socialSignInProviders} from "features/auth/models";
import {getAuthUserProfile, resetPasswordEmailVerify, verifyEmail,} from "redux/actions/auth";
import {getUserTotalPoints} from "../actions/reservations";


export interface IPoints {
  points: number
  loading: boolean
}


const initial: IPoints = {
  points: 0,
  loading: false
};

export const pointsSlice = createSlice({
  name: "pointsSlice",
  initialState: initial,
  reducers: {
    removeAvailablePoints: (state) => {
      state.points = 0;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserTotalPoints.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getUserTotalPoints.fulfilled, (state, action) => {
      state.points = action.payload;
      state.loading = false;
    });
    builder.addCase(getUserTotalPoints.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {removeAvailablePoints} = pointsSlice.actions;

export default pointsSlice.reducer;
